import type { GameCommand } from "../../semantic-command";
import type { GameplayEvaluationReceipt } from "../shared/adapter";
import type { TargetRangeSpec } from "./spec";

export function repairCommandsForTargetRange(spec: TargetRangeSpec, failedReceipt: GameplayEvaluationReceipt): readonly GameCommand[] | null {
  const failed = new Set(failedReceipt.checks.filter((check) => !check.passed).map((check) => check.id));
  if (!failed.size) return null;
  const params: Record<string, number> = {};
  if (failed.has("touch-target")) params.targetRadius = 32;
  if (failed.has("targets-reachable") || failed.has("protectees-survive") || failed.has("presentation-budget")) {
    // Escalating waves shorten travel time and stack concurrency; dropping
    // back to one wave is the least-destructive fix, tried alongside the
    // straightforward loosening.
    if ((spec.params.waves ?? 1) > 1) params.waves = 1;
  }
  if (failed.has("targets-reachable") || failed.has("protectees-survive")) {
    params.targetLifetimeSeconds = 6;
    params.projectileSpeed = 1_400;
    params.goalHits = Math.max(3, Math.round(spec.params.goalHits * 0.6));
  }
  return Object.keys(params).length ? [{ type: "set-params", params }] : null;
}
